module.exports = `${require.publicPath}icon18.493d5336.png`;